import { createContext, useContext } from 'react';

export const RolloutsContext = createContext({});
export const useRolloutsContext = () => useContext(RolloutsContext);
